import { SERVER_URL } from '../shared/constants';
import api from './api';

const BASE_URL = '/midia';

class midiaApi {
  // async getOne(params: Partial<Midia>) {
  //   try {
  //     let res = await api.get<Midia>('/empresa', { params });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async getMany(query: FindManyReq<Midia>) {
  //   try {
  //     let res = await api.post<Midia[]>('/empresa/get', query);
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async count(query: FindManyReq<Midia>) {
  //   try {
  //     let res = await api.post<number>('/empresa/count', query);
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async update(where: Partial<Midia>, update: Partial<Midia>) {
  //   try {
  //     let res = await api.put<Midia>('/empresa/', { empresa }, { params });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  async insert(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      // formData.set('id', id.toString());
      let res = await api.post<string>(BASE_URL, formData);
      return res.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  getMidia(arquivo: string) {
    if (!arquivo) {
      return '';
    }
    if (arquivo.startsWith('http')) {
      return arquivo;
    }
    const url = SERVER_URL;
    return `${url}${BASE_URL}/static/${arquivo}`;
  }
}

export default new midiaApi();
